export default __webpack_public_path__ + "static/media/913.291eacd7.jpg";